"use client"

import { useEffect, useRef } from "react"
import { toast } from "sonner"

export function useErrorToast( message?: string, key="") {
  const lastShownKeyRef = useRef<string>("")

  useEffect(() => {
    if (!message || !key) return
    if (lastShownKeyRef.current === key) return
    lastShownKeyRef.current = key
    toast.error(message)
  }, [key, message])
}
